module.exports = __webpack_public_path__ + "img/mac_mobile_ua.fe358aca.png";